import { render } from "./FooterPage.vue?vue&type=template&id=60ad0993"
const script = {}

import exportComponent from "/Users/salome/Desktop/salomeg5/bedoya_group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__